import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Clients from "@/components/sections/Clients";
import Contact from "@/components/sections/Contact";

export default function Home() {
  return (
    <div data-testid="home-page" className="bg-[#0A0A0A]">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <Process />
        <Clients />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
